import { inject, Injectable } from '@angular/core';
import { Prompt } from '../models/prompt';
import { ExtensionMessageService } from './extension-message.service';

@Injectable({ providedIn: 'root' })
export class PromptCopyService {
    private readonly extensionMessageService = inject(ExtensionMessageService);

    private async canWriteToClipboard(): Promise<boolean> {
        if (!navigator.clipboard) return false;
        if (!navigator.permissions) return true;
        try {
            const result = await navigator.permissions.query({ name: 'clipboard-write' as PermissionName });
            return result.state === 'granted' || result.state === 'prompt';
        } catch {
            return true;
        }
    }

    async copyPrompt(prompt: Prompt): Promise<boolean> {
        if (this.extensionMessageService.isExtensionContext()) {
            const response = await this.extensionMessageService.sendMessage('copyToClipboard', prompt.text);
            return response.success;
        }

        if (await this.canWriteToClipboard()) {
            try {
                await navigator.clipboard.writeText(prompt.text);
                return true;
            } catch {
                const textarea = document.createElement('textarea');
                textarea.value = prompt.text;
                document.body.appendChild(textarea);
                textarea.select();
                try {
                    document.execCommand('copy');
                    return true;
                } catch {
                    return false;
                } finally {
                    document.body.removeChild(textarea);
                }
            }
        }

        return false;
    }
}
